import React from "react";
import { Sparkles, Gem, Scissors, Heart, ShieldCheck } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { WHY } from "../../data/content";
import { SectionHead } from "./Ornament";
import { Reveal } from "../../lib/motion";

const ICONS = { Sparkles, Gem, Scissors, Heart, ShieldCheck };

export const WhyChooseUs = () => {
  const { t } = useLang();
  return (
    <section data-testid="why-section" className="bg-cream py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.why.overline} heading={S.why.heading} />
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {WHY.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title.en} delay={i * 0.08}>
                <div data-testid={`why-card-${i}`} className="group h-full flex flex-col items-center text-center px-4 py-8 rounded-lg border border-transparent hover:border-gold/30 hover:bg-ivory transition-all duration-500">
                  <div className="flex items-center justify-center w-14 h-14 rounded-full border border-gold/40 text-gold group-hover:bg-gold group-hover:text-burgundy transition-colors duration-500">
                    <Icon className="w-6 h-6" strokeWidth={1.4} />
                  </div>
                  <h3 className="mt-5 font-serif text-lg text-maroon leading-tight">{t(w.title)}</h3>
                  <p className="mt-2 text-maroon/60 text-xs sm:text-sm leading-relaxed">{t(w.text)}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
